import React from 'react'
import {EditGuesser} from '@api-platform/admin'
import {TextInput, NumberInput, ReferenceInput, AutocompleteInput, BooleanInput} from 'react-admin';
import {useTranslation} from "react-i18next";


function Edit(props) {
    const {t} = useTranslation()

    return (
        <EditGuesser {...props}>
            <TextInput source="name" label={t('common.name')}/>
            <ReferenceInput
                source="pool"
                reference="dictionary/pool_companies"
                label={t('brief.pool')}
            >
                <AutocompleteInput optionText="name"/>
            </ReferenceInput>
            <NumberInput source="mpmId" label={'mpmId'}/>
            <BooleanInput source="isBriefManyProducts" label={t('admin.isBriefManyProducts')}/>
            <BooleanInput source="isBriefManyChannels" label={t('admin.isBriefManyChannels')}/>
        </EditGuesser>
    )
}

export default Edit
